import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtxScrollSpyComponent } from './components/atx-scroll-spy.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxScrollSpyComponent,
    ],
    entryComponents: [
        AtxScrollSpyComponent,
    ],
    exports: [
        AtxScrollSpyComponent,
    ],
})

export class AtxScrollSpyModule {}
